module.exports = __webpack_public_path__ + "img/log2.c56bbdc9.png";